import { configuratorBuilder } from 'sunlife-domain'
import { createI18n } from 'sunlife-i18n'

import { adminComponents } from './admin/admin-components'
import { prePublishAdminHandler } from './admin/pre-publish-admin-handler'
import { sidebarComponents } from './dynamic-components/sidebar-components'
import { appEnvironmentElement } from './elements/app-environment'
import { appWrapperElement } from './elements/app-wrapper'
import { notAuthorizedAdminPageElement } from './elements/not-authorized-admin-page'
import { getThemeHandler } from './handlers/get-theme'
import { mapPublishDataHandler } from './handlers/map-publish-data'
import { onPresetLoadedHandler } from './handlers/on-preset-loaded'
import { webComponentOptionsHandler } from './handlers/web-component-options'
import { chooseFirstDesignOnCollectionChange } from './transformers/choose-first-desing-on-collection-change'
import { ensureLinerForTanThrough } from './transformers/ensure-liner-for-tan-through'
import { focusOnLiner, unFocusOnSelection } from './transformers/focus-on-liner'
import { resetPartsOnDesignChange } from './transformers/reset-parts-on-design-change'
import { customSidebarFooterElement } from './ui/finalize/CustomSidebarFooter'

export const config = configuratorBuilder
  .withI18n(createI18n())
  .withComponentOptics(sidebarComponents)
  .withAdminComponentOptics(adminComponents)
  .withElements([customSidebarFooterElement, appWrapperElement, appEnvironmentElement, notAuthorizedAdminPageElement])
  .withHandlers([
    getThemeHandler,
    mapPublishDataHandler,
    prePublishAdminHandler,
    webComponentOptionsHandler,
    onPresetLoadedHandler,
  ])
  .withTransformers(
    [
      { name: 'chooseFirstDesignOnCollectionChange', transformer: chooseFirstDesignOnCollectionChange },
      { name: 'resetPartsOnDesignChange', transformer: resetPartsOnDesignChange },
      { name: 'ensureLinerForTanThrough', transformer: ensureLinerForTanThrough },
      { name: 'focusOnLiner', transformer: focusOnLiner },
      { name: 'unFocusOnSelection', transformer: unFocusOnSelection },
    ],
    [
      { name: 'chooseFirstDesignOnCollectionChange', priority: Infinity },
      { name: 'resetPartsOnDesignChange', priority: Infinity },
      { name: 'ensureLinerForTanThrough', priority: Infinity },
      { name: 'focusOnLiner', priority: Infinity },
      { name: 'unFocusOnSelection', priority: Infinity },
    ]
  )
  .withDefaultEnvs({
    deploymentId: phoenix.runtimeConfig.DEPLOYMENT_ID,
    datadogEnabled: phoenix.runtimeConfig.DATADOG_ENABLED,
    datadogSite: phoenix.runtimeConfig.DATADOG_SITE,
    datadogClientToken: phoenix.runtimeConfig.DATADOG_CLIENT_TOKEN,
    serviceName: phoenix.runtimeConfig.SERVICE_NAME,
    persistenceMode: phoenix.runtimeConfig.PERSISTENCE_MODE,
    serverUrl: phoenix.runtimeConfig.SERVER_URL,
    resourcesUrl: phoenix.runtimeConfig.RESOURCES_URL,
    gtmId: phoenix.runtimeConfig.GTM_ID,
    gtmDebug: phoenix.runtimeConfig.GTM_DEBUG,
  })
  .buildConfig()
